"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeTimeOffRequest = void 0;
const action_1 = require("@app/action");
const time_off_remove_request_1 = require("@app/request/time-off-remove-request");
const util_1 = require("@app/util");
const store_1 = __importDefault(require("../store"));
const create_ac_1 = require("./util/create-ac");
exports.removeTimeOffRequest = (0, create_ac_1.createAC)(async (dispatch, { id }) => {
    const { workspaceId, timeOffs } = store_1.default.getState();
    if (!(0, util_1.isValue)(workspaceId)) {
        throw new Error('RemoveTimeOffRequest: workspaceId cannot be null or undefined');
    }
    const res = await (0, time_off_remove_request_1.requestTimeOffRemoveRequest)({ id, workspace: workspaceId });
    if ((0, util_1.isUndefined)(res)) {
        return false;
    }
    if (res) {
        const filteredTimeOffs = timeOffs.filter((t) => t.id !== id);
        dispatch((0, action_1.setTimeOffs)(filteredTimeOffs));
        return true;
    }
    return false;
});
